import React from "react";
import "./PrimaryNav.scss";
// import { NavLink } from "react-router-dom";
// import * as ROUTES from "constants/routes";

const PrimaryNav = () => (
  <nav className="PrimaryNav">
    <ul>
      {/* <li>
        <NavLink activeClassName="active" to={ROUTES.PROJECTS_HOME}>
          Projects
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName="active" to={ROUTES.CREATIVES_HOME}>
          Creatives
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName="active" to={ROUTES.BLOG_HOME}>
          Blog
        </NavLink>
      </li> */}
    </ul>
  </nav>
);

export default PrimaryNav;
